import { useLocation } from '@ksyos/router';
import { useUiStateContext } from '@frontend/utils/hooks/useUiState';
import { translateKey } from '../../translate';
import { FeedbackModal } from './FeedbackModal';
import { PopupButton } from './PopupButton';

export function Feedback() {
    const { pathname } = useLocation();
    const { uiState, dispatchUiStateAction } = useUiStateContext();

    return (
        <>
            <PopupButton
                onClick={() => dispatchUiStateAction({ type: 'setIsFeedbackModalOpen', isModalOpen: true })}
                style={{ marginTop: '-30px' }}
            >
                {translateKey('support.feedback')}
            </PopupButton>
            <FeedbackModal
                isOpen={uiState.isFeedbackModalOpen}
                onClose={() => dispatchUiStateAction({ type: 'setIsFeedbackModalOpen', isModalOpen: false })}
                url={pathname}
            />
        </>
    );
}
